export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/60"></div>
      <div
        className="absolute top-0 right-0 w-[600px] h-[600px] md:w-[800px] md:h-[800px] rounded-full bg-primary-100/40 blur-3xl -translate-y-1/4 translate-x-1/4"
      ></div>
      <div
        className="absolute bottom-0 left-0 w-[400px] h-[400px] md:w-[500px] md:h-[500px] rounded-full bg-accent-100/30 blur-3xl translate-y-1/4 -translate-x-1/4"
      ></div>

      <div className="relative w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>今日已更新 58 条热门瓜</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-4">
              在线吃瓜
              <span className="text-primary-500">全网热门八卦一站式聚合</span>
            </h1>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              不花钱、不注册，打开即看。我们每日从全网筛选最热、最新、最劲爆的吃瓜内容，
              涵盖娱乐圈八卦、网红热点、社会事件追踪，让你随时随地掌握最新瓜情。
              热门专题实时跟进，瓜友们都在这里讨论最火的话题。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8 text-sm text-foreground-500">
              <div className="flex items-center gap-2">
                <i className="ri-calendar-check-line text-accent-500 text-lg"></i>
                <span>每日免费更新</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-500 text-lg"></i>
                <span>安全匿名浏览</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-group-line text-accent-500 text-lg"></i>
                <span>百万瓜友聚集</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap text-base"
              >
                <i className="ri-compass-3-line"></i>
                开始吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-primary-300 text-primary-600 font-semibold rounded-full hover:bg-primary-50 transition-all cursor-pointer whitespace-nowrap text-base"
              >
                <i className="ri-fire-line"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] sm:w-[360px] sm:h-[360px] md:w-[420px] md:h-[420px] lg:w-[480px] lg:h-[480px]">
              <div className="absolute inset-0 rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20modern%20illustration%20style%20depicting%20online%20entertainment%20community%2C%20warm%20coral%20and%20teal%20color%20palette%2C%20playful%20social%20media%20vibe%20with%20speech%20bubbles%20and%20news%20elements%2C%20clean%20flat%20vector%20art%20style%2C%20energetic%20composition%20with%20people%20reading%20and%20sharing%20content%20on%20devices%2C%20soft%20gradient%20background%20with%20abstract%20geometric%20shapes%2C%20contemporary%20editorial%20illustration&width=960&height=960&seq=hero-main-2026-01&orientation=squarish"
                  alt="在线吃瓜娱乐社区主视觉"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-background-50 rounded-2xl p-4 border border-background-200/60">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-line-chart-line text-primary-500 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">今日热度</div>
                    <div className="text-lg font-bold text-primary-500">99万+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}